import { render, staticRenderFns } from "./PushesUser.vue?vue&type=template&id=e74d8834&"
import script from "./PushesUser.vue?vue&type=script&lang=js&"
export * from "./PushesUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports